<template>
  <div class="template-residential-template-summary">
    <h1 class="template-residential-template-summary__title">{{ title }}</h1>
    <div class="template-residential-template-summary__properties">
      <div
        class="template-residential-template-summary__property"
        v-for="(prop, index) in properties"
        :key="index"
      >
        <div class="template-residential-template-summary__property-label">
          {{ prop.label || $tc(prop.key) }}
        </div>
        <div class="template-residential-template-summary__property-value">
          {{ prop.formatted }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  computed: {
    title() {
      return this.$path('value.name')
    },
    properties() {
      if (!this.value || !this.value.properties) return []
      return this.value.properties.filter(p => p.formatted)
    },
  },
}
</script>

<style lang="scss">
.template-residential-template-summary {
  display: flex;
  flex-direction: column;
  padding: 0 6rem;
  background-color: hsla(var(--primary-h), var(--primary-s), var(--primary-l), 0.05);
  justify-content: center;
  @include respond-below('phone') {
    padding: 2rem 2rem;
  }

  &__title {
    margin: 0 0 1.5rem 0;
  }

  &__properties {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    grid-gap: 1rem 3rem;
  }

  &__property {
    border-top: solid 1px $border-color;
    padding: 0.5rem 0;

    display: flex;
    justify-content: space-between;

    &-label {
      font-weight: bold;
    }

    &-value {
      text-align: right;
      margin-left: 1rem;
    }
  }
}
</style>
